import styled from "styled-components";
import {Button} from "@material-ui/core";

export const Login2FAContent = styled.div`
  padding: 20px;
  width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Login2FAButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  
  & button {
    width: 100px;
  }
`;

interface ILogin2FAButtonProps {
    isDisabled?: boolean
}

export const Login2FAButton = styled(Button)`
  width: 100px;
  pointer-events: ${(props: ILogin2FAButtonProps) => props.isDisabled ? 'none' : 'auto'};
  
`;

export const Login2FAText = styled.div`
  text-align: center;
  font-size: 14px;
`;